import AfterDownloadPage from '../../pages/AfterDownloadPage';

export default AfterDownloadPage;
